import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton, RadioButtonList } from 'components';
import { HeadingItem } from 'components/heading-item/heading-item';
import { Popup } from 'devextreme-react';
import React, { FC, Fragment } from 'react';
import { EquipmentShortReason } from 'services/types';
import './short-pallet-pop-up.scss';

type Props = {
    isVisible: boolean,
    shortPallets: EquipmentShortReason[],
    selectedPalletShortReasons: EquipmentShortReason,
    otherValue?: string,
    onOtherValueChanged?: (otherValue: string) => void,
    onClickOk: () => void,
    handleRadioChecked: (itemKey: any) => void,
}

export const ShortPalletPopup: FC<Props> = ({ isVisible, shortPallets, selectedPalletShortReasons, otherValue, onOtherValueChanged = () => { }, onClickOk, handleRadioChecked }) => {

    const palletWithComment: EquipmentShortReason = shortPallets.find(pallet => pallet.isCommentRequired) ?? {} as EquipmentShortReason

    return (
        <Popup
            visible={isVisible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={330}
            height={360}
        >
            <Fragment>
                <HeadingItem text={'Reason for Short ?'} />
                <div className={'pallet-card-material'}>
                    <div className={'mass-refuse-radio-list'}>
                        <RadioButtonList<EquipmentShortReason>
                            data={shortPallets}
                            displayExpr={'description'}
                            valueExpr={'id'}
                            otherKeyValue={palletWithComment.id}
                            otherValue={otherValue}
                            onOtherValueChanged={value => onOtherValueChanged(value)}
                            selectedItem={selectedPalletShortReasons}
                            handleRadioChecked={reasonId => handleRadioChecked(reasonId)}
                        />
                    </div>
                </div>
                <div className={'bottom-fix-action-row'}>
                    <ActionButton
                        icon={faThumbsUp}
                        buttonColor={'#76AB21'}
                        onClick={onClickOk}
                        buttonText={'Ok'}
                    />
                </div>
            </Fragment>
        </Popup>
    )
}